
import React from 'react';
import { Button } from 'react-bootstrap';
import { FaDownload } from 'react-icons/fa';
import "../styles/descrecibo.css"

const DescargaRecibo = ({ recibo, userLegajo }) => {
    const [mes, anio] = recibo.Mes.split('/');
    const legajoFormateado = userLegajo.toString().padStart(4, '0');
    const secuencia = recibo.Secuencia; 
    const fileBase = `${anio}${mes}${secuencia}O${legajoFormateado}`;
    
    // Usar endpoint del backend - solo mes sin año
    const API_URL = (process.env.REACT_APP_API_URL || 'http://localhost:4004').replace(/\/$/, '');
    const pdfPath = `${API_URL}/api/recibos/${mes}/${secuencia}/${userLegajo}/pdf`;

    const handleDescarga = async () => {
        try {
            const token = localStorage.getItem('token');
            
            // ✅ SOLUCIÓN PARA iPhone: Abrir ventana ANTES del fetch (de forma síncrona)
            // Esto es necesario porque iOS bloquea window.open() si no se llama directamente en el evento
            const newWindow = window.open('', '_blank');
            
            // Mostrar mensaje de carga mientras se obtiene el PDF
            if (newWindow) {
                newWindow.document.write('<html><body><h2>Cargando recibo...</h2></body></html>');
            }
            
            // Descargar el PDF
            const response = await fetch(pdfPath, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            
            if (!response.ok) {
                throw new Error('Error al descargar el recibo');
            }
            
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            
            // Redirigir la ventana ya abierta al PDF
            if (newWindow) {
                newWindow.location.href = url;
            } else {
                // Fallback si el popup fue bloqueado: descargar directamente
                const a = document.createElement('a');
                a.href = url;
                a.download = fileBase + '.pdf';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            }
            
            // Liberar el objeto URL después de un tiempo
            setTimeout(() => window.URL.revokeObjectURL(url), 30000);
            
        } catch (error) {
            console.error('Error al descargar:', error);
            alert('Error al descargar el recibo. Por favor, inténtelo de nuevo.');
        }
    };

    return (
        <Button 
            className="btn btn-descargar action-btn"
            size="sm"
            onClick={handleDescarga}
            title="Descargar recibo"
        >
            <FaDownload />
        </Button>
    );
};

export default DescargaRecibo;